import { render, staticRenderFns } from "./MailSent.vue?vue&type=template&id=6d2b5064&scoped=true&"
import script from "./MailSent.vue?vue&type=script&lang=js&"
export * from "./MailSent.vue?vue&type=script&lang=js&"
import style0 from "./MailSent.vue?vue&type=style&index=0&id=6d2b5064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2b5064",
  null
  
)

export default component.exports